import React from "react";

function Footer() {
  return (
    <div className="footer-bg">
      <div className="wrapper">
        <p className="footer">
          &copy;2026 Tributum Power Private Limited Inc. All Rights Reserved. <b> | </b>
          <span>Concept & Design by eparivartan</span>
        </p>
      </div>
    </div>
  );
}

export default Footer;
